import * as XLSX from 'xlsx';

export interface ContractExportPayload {
    contract: Record<string, unknown>;
    ledger: {
        type: string;
        amount: string;
        balance_after: string;
        description: string;
        effective_at: string;
    }[];
    exported_at: string;
}

export function buildContractWorkbook(data: ContractExportPayload): XLSX.WorkBook {
    const workbook = XLSX.utils.book_new();
    const contract = data.contract;
    const summaryRows: (string | number | null)[][] = [
        ['DebtBound Contract Export'],
        ['Exported At', data.exported_at],
        [],
        ['CONTRACT SUMMARY'],
        ['Title', contract.title as string],
        ['Status', contract.status as string],
        ['Dom', contract.dom as string],
        ['Sub', contract.sub as string],
        [],
        ['DATES'],
        ['Start Date', (contract.start_date as string) || 'Upon signing'],
        ['Close Date', contract.close_date as string | null ?? '—'],
        [],
        ['FINANCIAL TERMS'],
        ['Opening Balance', contract.opening_balance as number],
        ['Current Balance', contract.current_balance as number],
        ['Interest Rate (%)', contract.interest_rate as number],
        ['Compounding Frequency', contract.compounding_frequency as string],
        ['Minimum Payment', contract.minimum_payment as number],
        ['Maximum Payment', contract.maximum_payment as number | null ?? '—'],
        ['Payment Due Day', contract.payment_due_day as number],
        ['Funding Source', contract.funding_source as string],
        [],
        ['FEES & TOTALS'],
        ['Origination Fee', contract.origination_fee as number],
        ['Admin Fee Amount', contract.admin_fee_amount as number],
        ['Admin Fee Frequency', contract.admin_fee_frequency as string],
        ['Total Paid', contract.total_paid as number],
        ['Total Interest Charged', contract.total_interest_charged as number],
        ['Total Fees Charged', contract.total_fees_charged as number],
        ['Total Taxes Assessed', contract.total_taxes_assessed as number],
    ];
    const summarySheet = XLSX.utils.aoa_to_sheet(summaryRows);
    summarySheet['!cols'] = [{ wch: 28 }, { wch: 30 }];
    XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary');

    const ledgerRows: (string | number)[][] = [
        ['Date', 'Type', 'Description', 'Amount', 'Balance After'],
        ...data.ledger.map((entry) => [
            entry.effective_at,
            entry.type,
            entry.description ?? '',
            parseFloat(entry.amount),
            parseFloat(entry.balance_after),
        ]),
    ];
    const ledgerSheet = XLSX.utils.aoa_to_sheet(ledgerRows);
    ledgerSheet['!cols'] = [{ wch: 22 }, { wch: 16 }, { wch: 40 }, { wch: 12 }, { wch: 14 }];
    XLSX.utils.book_append_sheet(workbook, ledgerSheet, 'Ledger');

    return workbook;
}

export function contractWorkbookFilename(contractId: number | string): string {
    return `contract-${contractId}-export.xlsx`;
}

export function downloadContractWorkbook(data: ContractExportPayload, contractId: number | string): void {
    XLSX.writeFile(buildContractWorkbook(data), contractWorkbookFilename(contractId));
}
